import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

export type TooltipPosition = 'bottom' | 'end' | 'start' | 'top';

/**
 * Wraps a component to _optionally_ display a tooltip.
 */
@Component({
  selector: 'cc-optional-tooltip-wrapper',
  templateUrl: './optional-tooltip-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgTemplateOutlet],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OptionalTooltipWrapperComponent {
  @Input() public tooltipPosition: TooltipPosition = 'top';
  @Input() public displayTooltip = true;
}
